import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Layout } from "@/components/Layout";
import { AuthProvider, useAuth } from "@/lib/AuthContext";
import { ChatProvider } from "@/lib/ChatContext";
import { ToastsProvider } from "@/components/ui/toast";
import { Home } from "@/routes/Home";
import { Triage } from "@/routes/Triage";
import { Creators } from "@/routes/Creators";
import { CreatorDetail } from "@/routes/CreatorDetail";
import { System } from "@/routes/System";
import { Costs } from "@/routes/Costs";
import { Recruiting } from "@/routes/Recruiting";
import { Recruiters } from "@/routes/Recruiters";
import { Drafts } from "@/routes/Drafts";
import { Activity } from "@/routes/Activity";
import { Fleet } from "@/routes/Fleet";
import { Ultradash } from "@/routes/Ultradash";
import { UltradashQueue } from "@/routes/UltradashQueue";
import { Login } from "@/routes/Login";

function AuthGuard({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) {
    return (
      <div className="grid h-screen place-items-center text-sm text-muted-foreground">
        <div className="flex items-center gap-2">
          <span className="h-1.5 w-1.5 animate-pulse-soft rounded-full bg-brand" />
          loading
        </div>
      </div>
    );
  }
  if (!user) {
    const returnTo = loc.pathname + loc.search;
    return <Navigate to={`/login?returnTo=${encodeURIComponent(returnTo)}`} replace />;
  }
  return <>{children}</>;
}

export default function App() {
  return (
    <TooltipProvider delayDuration={150}>
      <ToastsProvider>
        <AuthProvider>
          <ChatProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/*"
                element={
                  <AuthGuard>
                    <Layout>
                      <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/triage" element={<Triage />} />
                        <Route path="/creators" element={<Creators />} />
                        <Route path="/creators/:creatorId" element={<CreatorDetail />} />
                        <Route path="/system" element={<System />} />
                        <Route path="/costs" element={<Costs />} />
                        <Route path="/recruiting" element={<Recruiting />} />
                        <Route path="/recruiters" element={<Recruiters />} />
                        <Route path="/drafts" element={<Drafts />} />
                        <Route path="/activity" element={<Activity />} />
                        <Route path="/fleet" element={<Fleet />} />
                        <Route path="/ultradash" element={<Ultradash />} />
                        <Route path="/ultradash/queue" element={<UltradashQueue />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                      </Routes>
                    </Layout>
                  </AuthGuard>
                }
              />
            </Routes>
          </ChatProvider>
        </AuthProvider>
      </ToastsProvider>
    </TooltipProvider>
  );
}
